// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__iMPmv","header":"ClearentDisclaimer_header__2Lq-h","inner":"ClearentDisclaimer_inner__Oz-T5"};